import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { TypeService } from '@thewhite/react-global-module/lib/services';

export enum GenderEnum {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export interface Gender {
    [value: string]: SimpleObjectInterface;

    MALE: SimpleObjectInterface;
    FEMALE: SimpleObjectInterface;
}

const GENDER: Gender = {
    MALE: {
        name: 'Мужчина',
        value: 'MALE',
    },
    FEMALE : {
        name: 'Женщина',
        value: 'FEMALE',
    },
};

export default GENDER;

export const GenderEnumType = TypeService.createEnum<GenderEnum>(GenderEnum, 'GenderEnum');
